import { createGlobalStyle } from 'styled-components';
import img from './eva.jpg';

const ExamsStyle = createGlobalStyle`
body {
    background: url('${img}') no-repeat center center fixed;
    background-size: cover;
    background-color: #0a0a0a;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Exams Main Container */
.exams-main {
    min-height: calc(100vh - 140px);
    padding: 2rem 1rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.exams-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
}

/* Exams Card */
.exams-card {
    padding: 2rem;
    background: linear-gradient(135deg, rgba(30, 10, 40, 0.75) 0%, rgba(60, 20, 80, 0.75) 100%);
    border: 2px solid #673ab7;
    border-radius: 10px;
    box-shadow: 0 0 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    animation: shadow-move-purple 4s infinite alternate;
    backdrop-filter: blur(5px);
    position: relative;
    overflow: hidden;
}

.exams-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(103, 58, 183, 0.03) 2px,
        rgba(103, 58, 183, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
}

@keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
}

@keyframes shadow-move-purple {
    0% {
        box-shadow: 0 0 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(166, 13, 224, 0.4), 0 0 20px rgba(103, 58, 183, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(166, 13, 224, 0.4), 0 0 20px rgba(103, 58, 183, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
}

/* Header */
.exams-header {
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    z-index: 1;
}

.exams-title {
    font-size: 2rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 15px rgba(166, 13, 224, 0.8);
    background: rgba(0, 0, 0, 0.6);
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 10px;
    border: 2px solid #673ab7;
    margin: 0;
    animation: electric 0.8s infinite;
}

/* Content */
.exams-content {
    position: relative;
    z-index: 1;
}

.exams-text {
    font-size: 1.25rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    line-height: 1.8;
    margin: 2rem 0;
    text-align: left;
}

.exams-greeting {
    text-align: center;
    margin: 2rem 0;
}

.exams-greeting h2 {
    font-size: 1.75rem;
    font-weight: bold;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.8);
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 10px;
    border: 2px solid #673ab7;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    margin: 0;
    animation: electric 0.8s infinite;
}

/* Button */
.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem 0;
}

.button {
    display: inline-block;
    padding: 1rem 2rem;
    background: linear-gradient(135deg, #673ab7 0%, #A60DE0 100%);
    color: #ffffff;
    text-decoration: none;
    border-radius: 5px;
    border: 2px solid #A60DE0;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
    transition: all 0.3s ease;
    font-size: 1.1rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.button:hover {
    transform: scale(1.05);
    color: #ffff00;
    box-shadow: 0 0 40px rgba(166, 13, 224, 0.8), inset 0 0 20px rgba(166, 13, 224, 0.3);
    background: linear-gradient(135deg, #A60DE0 0%, #673ab7 100%);
    animation: electric 0.8s infinite;
}

/* Nav Menu Hover Effects */
header {
    background-color: #333;
    padding: 20px;
    padding-bottom: 30px;
    margin: 0 auto;
}

nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

nav ul li {
    display: inline-block;
    margin-right: 20px;
}

nav ul li:last-child {
    margin-right: 0;
}

nav ul li a, nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
    color: #673ab7;
    text-shadow: 1px 1px 2px #673ab7, 0 0 1em #A60DE0, 0 0 0.2em yellow;
    animation: electric 0.8s infinite;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    margin-top: auto;
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
} */

/* Animations */
@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        text-shadow: 2px 2px 8px yellow, 0 0 20px red;
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

@keyframes electricbox {
    0% {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        box-shadow: 2px 2px 8px #ffff00, 0 0 20px #ff0000;
    }
    100% {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .exams-main {
        padding: 1rem 0.75rem;
    }

    .exams-card {
        padding: 1.5rem;
    }

    .exams-title {
        font-size: 1.5rem;
        padding: 0.75rem 1.5rem;
    }

    .exams-text {
        font-size: 1.1rem;
    }

    .exams-greeting h2 {
        font-size: 1.25rem;
        padding: 0.75rem 1.5rem;
    }

    .button {
        width: 100%;
        text-align: center;
    }
}
`;

export default ExamsStyle;
